import { render, staticRenderFns } from "./datepicker-box.vue?vue&type=template&id=00647056&scoped=true&"
import script from "./datepicker-box.vue?vue&type=script&lang=js&"
export * from "./datepicker-box.vue?vue&type=script&lang=js&"
import style0 from "./datepicker-box.vue?vue&type=style&index=0&id=00647056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00647056",
  null
  
)

export default component.exports